import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoList = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>List</title>
    <path
      d="M11.997 8.986h14.857M11.998 16.988H22.46M11.998 24.987h13.49"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={6.857} cy={8.987} r={1.714} fill="currentColor" />
    <circle cx={6.857} cy={16.985} r={1.714} fill="currentColor" />
    <circle cx={6.857} cy={24.988} r={1.714} fill="currentColor" />
  </svg>
);
export default SvgIcoList;
